import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { RoutesList } from 'src/app/models/enums/RoutesList';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { PortalLoggedinUsers } from 'src/app/shared/services/portal-loggedin-users.service';
import { environment } from 'src/environments/environment';
import { DataService } from 'src/app/shared/services/data.service';
import { RouterService } from 'src/app/shared/services/router.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { PersonalizationPopup } from '../../personalization-popup/personalization-popup';
import { MatDialog } from '@angular/material/dialog';
import { PortalLogOutExitCode } from 'src/app/models/enums/logOutExitCode';

@Component({
  selector: 'app-sidebar-account-info',
  templateUrl: './sidebar-account-info.component.html',
  styleUrls: [
    './sidebar-account-info.component.scss',
    './sidebar-account-info.component.en.scss',
  ],
  animations: [
    trigger('openClose', [
      state('opened', style({
        height: '*',
        opacity: 1
      })),
      state('closed', style({
        height: '0',
        opacity: 0
      })),
      transition('opened => closed', [
        animate('.2s')
      ]),
      transition('closed => opened', [
        animate('0.2s')
      ])
    ])
  ]
})
export class SidebarAccountInfoComponent {

  @Input() generalSettingsData: any;
  @Input() pageUrl: string | unknown;

  @Output() closeSidebar = new EventEmitter<void>();

  opened: boolean = false;
  name: string = '';

  constructor(
    private authService: AuthService,
    private personalizationPopup: MatDialog,
  ) {}

  onLogout(): void {
    return this.authService.logout(PortalLogOutExitCode.LogOutByUser);
  }

  changeSessionView(sesionEnum: any) {
    return this.authService.changeSessionView(sesionEnum);
  }

  openAccountSettingsPopup() {
    this.closeSidebar.emit();
    this.personalizationPopup.open(PersonalizationPopup);
  }
}
